import { Component } from 'preact'
// import axios from 'axios'
import { AlertMessage, EscalateButton } from '../EscalationButtons'
import {
  ConfigContext,
  getFormattedContent,
  getFormattedTitle,
  showEscalateButton
} from '../../utils'
import { ContentType } from '@insided/shared/utils/contentType'
import CreateIntercomConversationModal from './CreateIntercomConversationModal'
import { publish } from '@insided/deprecated-utils/globals'

interface Props {
  isEnabled: boolean
  title?: string
  username?: string
  userId: string
  content?: string | null
  publicId: number
  moderatorId: string
  isReply: boolean
  contentType: ContentType
  isTrashed: boolean
  destinationUrl: string
  topicId: number
}

interface State {
  showModal: boolean
  conversationUrl: string | null
  isLoading: boolean
  body: string | undefined
  messageType?: string|null
  message?: string
  errorFields?: string []
}

class CreateIntercomConversationButton extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      showModal: false,
      conversationUrl: null,
      isLoading: false,
      body: this.getFormattedBody()
    }
    this.fetchConversationUrl = this.fetchConversationUrl.bind(this)
    this.createConversation = this.createConversation.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.onChangeBody = this.onChangeBody.bind(this)
    this.removeValidationErrorFromInputField = this.removeValidationErrorFromInputField.bind(this)
  }

  async componentDidMount () {
    if (this.props.isEnabled) {
      await this.fetchConversationUrl()
    }
  }

  getFormattedBody() {
    const subject = `Subject: ${getFormattedTitle(this.props.title, this.props.isReply) ?? ''}\n------------------\n`
    const description = `Description: ${getFormattedContent(this.props.contentType, this.props.destinationUrl, this.props.topicId, this.props.content)}`

    return `${subject} ${description}`
  }

  componentDidUpdate (previousProps: Readonly<Props>) {
    if (this.props.isTrashed !== previousProps.isTrashed) {
      this.setState({ messageType: null })
    }
  }

  async fetchConversationUrl () {
    console.log('fetchConversationUrl called')
    // this.setState({ isLoading: true })
    // try {
    //   const data = {
    //     postId: this.props.publicId,
    //     isReply: this.props.isReply,
    //     contentType: this.props.contentType,
    //     type: 'intercom'
    //   }
    //   const result = await axios.get('/escalation/fetch', { params: data })
    //   const conversationUrl = result.data.ticketUrl
    //   this.setState({ conversationUrl: conversationUrl, isLoading: false })
    // } catch (e) {
    //   this.setState({ conversationUrl: null, isLoading: false })
    // }
  }

  removeValidationErrorFromInputField (inputField: string) {
    if (this.state.errorFields?.includes(inputField)) {
      const fields = this.state.errorFields?.filter((value) => value !== inputField)
      this.setState({
        errorFields: fields
      })
    }
  }

  async createConversation () {
    const { body } = this.state
    const formattedBody = body?.trim()
    const validatedFields = []
    if (formattedBody === '') {
      validatedFields.push('body')
    }

    if (validatedFields.length !== 0) {
      this.setState({
        errorFields: validatedFields
      })
      return
    }
    const { moderatorId, publicId, isReply, username, userId, contentType } = this.props

    const params = {
      moderatorId: moderatorId,
      postId: publicId,
      isReply: isReply,
      contentType: contentType,
      type: 'intercom',
      body: body,
      authorUsername: username,
      authorUserId: userId
    }
    console.log(params)

    console.log('clicked createConversation')
    const isReplyToString = isReply.toString()
    const id = `${publicId}:${contentType}:${isReplyToString}`
    publish('intercom_conversation_created', { url: 'testURL', id: id })
  }

  closeModal () {
    this.setState({
      showModal: false,
      body: this.getFormattedBody(),
      errorFields: []
    })
  }

  showCreateConversationModal () {
    this.setState({
      showModal: true,
      messageType: null
    })
  }

  onChangeBody(data: string) {
    this.setState({ body: data })
  }

  render () {
    const { isEnabled, isReply, userId, username, contentType } = this.props
    const { isLoading, showModal, messageType, message, body, errorFields, conversationUrl } = this.state
    if (!isEnabled) {
      return null
    }
    return (
      <ConfigContext.Consumer>
        {({ moderationConfig: { escalate, escalateReply } }) => {
          const showEscalationButton = userId && showEscalateButton(escalate, escalateReply, isReply, Boolean(conversationUrl), contentType)
          return (
            <div className='integration__escalate qa-escalate-intercom'>
              <AlertMessage messageType={messageType} message={message} />
              {showEscalationButton &&
                <div>
                  <EscalateButton
                    isDisabled={isLoading}
                    tooltipMessage='Create an Intercom conversation'
                    imageName='intercom-xs'
                    onClick={() => this.showCreateConversationModal()}
                    customClasses='qa-create-intercom-conversation'
                  />
                  <CreateIntercomConversationModal
                    modalTitle='Create an Intercom conversation'
                    modalTitleImage='intercom'
                    isOpen={showModal}
                    closeModal={() => this.closeModal()}
                    username={username}
                    body={body}
                    onContentChange={(data: string) => this.onChangeBody(data)}
                    onSubmit={async () => await this.createConversation()}
                    onTextareaFocus={() => this.removeValidationErrorFromInputField('body')}
                    isLoading={isLoading}
                    errorFields={errorFields}
                  />
                </div>}
            </div>
            )
        }}
      </ConfigContext.Consumer>
    )
  }
}

export default CreateIntercomConversationButton
